import { swrCacheStore } from '@spx-portal/shared-utils';
import { useCallback } from 'react';
import { u as useSyncExternalStoreExports } from '../node_modules/.pnpm/use-sync-external-store@1.2.2_react@18.2.0/node_modules/use-sync-external-store/index.js';

function useSWR(cacheKey) {
    return useSyncExternalStoreExports.useSyncExternalStore(useCallback(function (listener) {
        return swrCacheStore.subscribe(cacheKey, listener);
    }, [cacheKey]), useCallback(function () {
        return swrCacheStore.load(cacheKey);
    }, [cacheKey]));
}

export { useSWR as default };
